import React from "react";
import { useTranslation } from "react-i18next";
import { formatCurrency, isDefined } from "../../Utils";

const AvoirCommandeSummary = ({ isParticulier, data }) => {
  const { t } = useTranslation("common");
  const summary = [
    {
      label: t("Total product price excl. tax (€)"),
      value: data?.attributes?.totalProductsHT,
      hidden: isParticulier,
    },
    {
      label: t("Total excl. tax"),
      value: data?.attributes?.totalHT,
      hidden: isParticulier,
    },
    {
      label: t("VAT"),
      value: data?.attributes?.TVA,
      hidden: isParticulier || !data?.attributes?.TVA,
    },
    {
      label: t("Total incl. tax"),
      value: data?.attributes?.totalTTC,
      hidden: !data?.attributes?.TVA && !isParticulier,
    },
  ];
  return (
    <div className="f14 bold text-dark">
      <div className="br10 p-2 d-flex flex-column w100">
        {summary.map(
          ({ label, value, hidden }) =>
            isDefined(value) &&
            !hidden && (
              <div className="d-flex flex-grow-1 justify-content-between">
                <span className="f12 bold">{label}</span>
                <span className="f12 bold">{formatCurrency(value)}</span>
              </div>
            )
        )}
      </div>
    </div>
  );
};

export default AvoirCommandeSummary;
